import { render, staticRenderFns } from "./CreateItem.vue?vue&type=template&id=077a28b0&scoped=true&"
import script from "./CreateItem.vue?vue&type=script&lang=js&"
export * from "./CreateItem.vue?vue&type=script&lang=js&"
import style0 from "./CreateItem.vue?vue&type=style&index=0&id=077a28b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077a28b0",
  null
  
)

export default component.exports